'use client';

import React, {useState} from "react";
import productCardCss from '@/parts/ProductCard/product-card.module.scss';
import ModalVideo from "vadimages-react-modal-video";
import ScrollSnapRow from "@/components/ScrollSnapRow/ScrollSnapRow";
import GanjierMobileVideoThumbnail from "@/app/parts/product-detail/MiniProMobileVideoThumbnail";

const MiniProThreeGanjiersSlider = ({ mobileVideoIds, imageDirectory }: { mobileVideoIds: number[], imageDirectory: string }) => {
    const [isOpen, setOpen] = useState<number>(-1);

    // Was a Swiper row (slidesPerView 'auto', fixed 200px slides); now native CSS scroll-snap.
    // slidesPerView 'auto' -> fixed w-[200px] slides; spaceBetween 20 -> gap-5.
    return <div className={productCardCss['slider-wrapper']}>
        {
            mobileVideoIds.map((videoId, key) => (
                <ModalVideo
                    key={`ganjier-mobile-video-${key + 1}}`}
                    channel='vimeo'
                    isOpen={isOpen === key}
                    videoId={videoId.toString()}
                    onClose={() => setOpen(-1)}
                    ratio='9:16'
                />
            ))
        }
        <ScrollSnapRow
            className='w-fit mb-20'
            trackClassName='gap-5'
            itemClassName='w-[200px]'
            snap='proximity'
        >
            {
                mobileVideoIds.map((_, key) => (
                    <GanjierMobileVideoThumbnail
                        key={key}
                        onClick={() => setOpen(key)}
                        id={key}
                        imageDirectory={imageDirectory}
                    />
                ))
            }
        </ScrollSnapRow>
    </div>
}

export default MiniProThreeGanjiersSlider;
